const types = {
	new_affiliate: 'new_affiliate',
	new_affiliate_resend_activation: 'new_affiliate_resend_activation',
	password_remind: 'password_remind',
	new_thread: 'new_thread',
	new_thread_post: 'new_thread_post',
	new_offer: 'new_offer',
	offer_change: 'offer_change',
	promo: 'promo',
	system_news: 'system_news',
	payout_status_change: 'payout_status_change',
	digest: 'digest',
	affiliate_confirmed_email: 'affiliate_confirmed_email',
	daily_news: 'daily_news',
	inactive_three_days: 'inactive_three_days',
	inactive_seven_days: 'inactive_seven_days',
	first_approves: 'first_approves',
	manual_affiliate_registration: 'manual_affiliate_registration',
	sessions_delete: 'sessions_delete',
	password_change: 'password_change',
	password_forgot: 'password_forgot',
	affiliate_inactive: 'affiliate_inactive',
	welcome_email: 'welcome_email',
	payout_credentials_confirmation: 'payout_credentials_confirmation'
};

const locale = {
	ru: {
		new_affiliate: 'новый пользователь',
		password_remind: 'возобновление пароля',
		new_thread: 'новый тикет от администрации',
		new_thread_post: 'новый ответ в тикете',
		new_offer: 'новые офферы',
		offer_change: 'изменения в работе офферов',
		promo: 'промо акции',
		system_news: 'системные уведомления',
		payout_status_change: 'изменение статуса выплаты',
		digest: 'дайджесты',
		affiliate_confirmed_email: 'пользователь подтвердил имейл',
		daily_news: 'ежедневные новости',
		inactive_three_days: 'нет активности через 3 дня',
		inactive_seven_days: 'нет активности через 7 дня',
		first_approves: 'первые апрувы',
		manual_affiliate_registration: 'ручная регистрация пользователя',
		sessions_delete: 'удаление сессий',
		password_change: 'пароль изменён',
		password_forgot: 'сменить пароль по ссылке',
		affiliate_inactive: 'пользователь получил статус не активен',
		welcome_email: 'приветственое письмо',
		payout_credentials_confirmation: 'подтверждение платежных данных'
	},
	en: {
		new_affiliate: 'new affiliate (verification)',
		password_remind: 'password reminder',
		new_thread: 'new ticket from admins',
		new_thread_post: 'new post in ticket',
		new_offer: 'new offers',
		offer_change: 'changes in offers',
		promo: 'promo events',
		system_news: 'system notifications',
		payout_status_change: 'payout status change',
		digest: 'digests',
		affiliate_confirmed_email: 'affiliate confirmed email',
		daily_news: 'daily news',
		inactive_three_days: 'no activity after 3 days',
		inactive_seven_days: 'no activity after 7 days',
		first_approves: 'first approves',
		manual_affiliate_registration: 'manual affiliate registration',
		sessions_delete: 'sessions delete',
		password_change: 'password change',
		password_forgot: 'change password via link',
		affiliate_inactive: 'affiliate inactive',
		welcome_email: 'welcome email'
	},
	uk: {
		new_affiliate: 'new affiliate (verification)',
		password_remind: 'password reminder',
		new_thread: 'new ticket from admins',
		new_thread_post: 'new post in ticket',
		new_offer: 'new offers',
		offer_change: 'changes in offers',
		promo: 'promo events',
		system_news: 'system notifications',
		payout_status_change: 'payout status change',
		digest: 'digests',
		affiliate_confirmed_email: 'affiliate confirmed email',
		daily_news: 'daily news',
		inactive_three_days: 'no activity after 3 days',
		inactive_seven_days: 'no activity after 7 days',
		first_approves: 'first approves',
		manual_affiliate_registration: 'manual affiliate registration',
		sessions_delete: 'sessions delete',
		password_change: 'password change',
		password_forgot: 'change password via link',
		affiliate_inactive: 'affiliate inactive',
		welcome_email: 'welcome email',
		payout_credentials_confirmation: 'payout credentials confirmation'
	},
	de: {
		new_affiliate: 'new affiliate (verification)',
		password_remind: 'password reminder',
		new_thread: 'new ticket from admins',
		new_thread_post: 'new post in ticket',
		new_offer: 'new offers',
		offer_change: 'changes in offers',
		promo: 'promo events',
		system_news: 'system notifications',
		payout_status_change: 'payout status change',
		digest: 'digests',
		affiliate_confirmed_email: 'affiliate confirmed email',
		daily_news: 'daily news',
		inactive_three_days: 'no activity after 3 days',
		inactive_seven_days: 'no activity after 7 days',
		first_approves: 'first approves',
		manual_affiliate_registration: 'manual affiliate registration',
		sessions_delete: 'sessions delete',
		password_change: 'password change',
		password_forgot: 'change password via link',
		affiliate_inactive: 'affiliate inactive',
		welcome_email: 'welcome email',
		payout_credentials_confirmation: 'payout credentials confirmation'
	},
	vi: {
		new_affiliate: 'new affiliate (verification)',
		password_remind: 'password reminder',
		new_thread: 'new ticket from admins',
		new_thread_post: 'new post in ticket',
		new_offer: 'new offers',
		offer_change: 'changes in offers',
		promo: 'promo events',
		system_news: 'system notifications',
		payout_status_change: 'payout status change',
		digest: 'digests',
		affiliate_confirmed_email: 'affiliate confirmed email',
		daily_news: 'daily news',
		inactive_three_days: 'no activity after 3 days',
		inactive_seven_days: 'no activity after 7 days',
		first_approves: 'first approves',
		manual_affiliate_registration: 'manual affiliate registration',
		sessions_delete: 'sessions delete',
		password_change: 'password change',
		password_forgot: 'change password via link',
		affiliate_inactive: 'affiliate inactive',
		welcome_email: 'welcome email',
		payout_credentials_confirmation: 'payout credentials confirmation'
	},
	th: {
		new_affiliate: 'ผู้ใช้ใหม่',
		password_remind: 'ต่ออายุรหัสใหม่',
		new_thread: 'หมายเลขใหม่จากผู้อนุมัติ',
		new_thread_post: 'คำตอบใหม่ในหน้าเว็บไซต์',
		new_offer: 'การเปลี่ยนแปลงในการทำข้อเสนอ',
		offer_change: 'การเปลี่ยนแปลงข้อเสนอพิเศษ',
		promo: 'กิจกรรมส่งเสริมการขาย',
		system_news: 'การแจ้งข่าวอย่างเป็นระบบ',
		payout_status_change: 'เปลี่ยนสถานะการชำระเงิน',
		digest: 'ข้อความสรุป',
		affiliate_confirmed_email: 'ยืนยันอีเมลแล้ว',
		daily_news: 'daily news',
		inactive_three_days: 'no activity after 3 days',
		inactive_seven_days: 'no activity after 7 days',
		first_approves: 'first approves',
		manual_affiliate_registration: 'manual affiliate registration',
		sessions_delete: 'sessions delete',
		password_change: 'password change',
		password_forgot: 'change password via link',
		affiliate_inactive: 'affiliate inactive',
		welcome_email: 'welcome email',
		payout_credentials_confirmation: 'payout credentials confirmation'
	}
};

module.exports = {
	enum: types,
	locale: locale
};


// WEBPACK FOOTER //
// ./enums/notification-event-types.js